import React, { useEffect, useRef } from 'react';

const Newsletter = () => {
  const containerRef = useRef(null);
  const initializedRef = useRef(false);

  useEffect(() => {
    if (initializedRef.current) return;

    const containerEl = containerRef.current;
    let cancelled = false;

    const hasIframe = () => !!(containerEl && containerEl.querySelector('iframe'));

    const attemptInit = (attempt = 0) => {
      if (cancelled) return;
      if (hasIframe()) {
        initializedRef.current = true;
        return;
      }
      if (window.SignupFormWidget && typeof window.SignupFormWidget.init === 'function') {
        try {
          window.SignupFormWidget.init();
        } catch (_) {}
      }
      if (attempt < 6 && !hasIframe()) {
        setTimeout(() => attemptInit(attempt + 1), 250 + attempt * 200);
      }
    };

    const timer = setTimeout(() => attemptInit(0), 100);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, []);

  return (
    <section id="newsletter" className="newsletter-section">
      <div className="newsletter-container">
        <h2>Stay Connected</h2>
        {/* Begin Constant Contact Inline Form Code */}
        <div ref={containerRef} className="ctct-inline-form" data-form-id="93a82e8d-24fa-4e98-be72-0fafcbdea63d"></div>
        {/* End Constant Contact Inline Form Code */}
      </div>
    </section>
  );
};

export default Newsletter;
